<template>
  <v-dialog v-model="dialog" max-width="400">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        color="error"
        icon
        title="Remover formação de carga"
        ><v-icon>mdi-delete-outline</v-icon></v-btn
      >
    </template>
    <v-card :disabled="removendo">
      <v-card-title class="font-weight-bold"
        >Remover formação da carga</v-card-title
      >
      <v-card-subtitle
        >Você está removendo a seguinte formação de carga:</v-card-subtitle
      >
      <v-card-text>
        <ul>
          <li>ID: {{ carga.id }}</li>
          <li>Descrição: {{ carga.descricao }}</li>
          <li>Data inclusão: {{ formatarData(carga.data) }}</li>
          <li>Placa: {{ carga.placa }}</li>
          <li>Vendedor: {{ carga.desc_vendedor }}</li>
        </ul>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="remover()"
          rounded
          color="success"
          :loading="removendo"
          >Confirmar</v-btn
        >
        <v-btn text @click="dialog = false" rounded>Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  props: {
    carga: { type: Object, required: true },
  },
  computed: {
    ...mapState("formacaoCarga", ["cargas"]),
  },
  data: () => ({
    dialog: false,
    removendo: false,
  }),
  methods: {
    ...mapMutations("formacaoCarga", ["setIdCarga"]),
    ...mapActions("formacaoCarga", ["buscarCargas"]),
    formatarData(value) {
      return moment(value).format("DD/MM/yyyy");
    },
    async remover() {
      this.removendo = true;
      await axios
        .delete("/nutricao-animal/formacao-carga/cargas", {
          params: {
            id: this.carga.id,
          },
        })
        .then(async (res) => {
          if (res.data.success) {
            this.$toasted.success(res.data.msg);
            this.setIdCarga(0);
            await this.buscarCargas();
          } else this.$toasted.error(res.data.msg);
        })
        .catch((error) => {
          this.$toasted.error(error);
        });
      this.removendo = false;
    },
  },
};
</script>

<style>
</style>